const handleLinkClient = (message, data) => {
    if (message === 'EXTERNAL/LINK') {
        if (data.includes('mail:to')) {
            window.top.open(data)
        } else {
            window.open(data, '_blank')
        }
    }

    return true
}

export default handleLinkClient
